export default {
  Success: 'Success',
  Error: 'Error',
  ValidationError: 'ValidationError',
};
